<script lang="ts">
    import Icon from '@iconify/svelte'
    import { DateTime } from 'luxon'
    import { cart, items } from 'services/cart'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { sanchor, sgoto, spath } from 'hydria/svelte_helpers'

    import { DOMAIN_EXPIRATION_IMMINENT, DOMAIN_EXPIRATION_SOON } from 'wdom/constants'
    import { subaccount } from 'wdom/subaccount'

    interface Props {
        zoneIdna: string
        zoneUnicode: string
        expiration: DateTime
    }

    let { zoneIdna, zoneUnicode, expiration }: Props = $props()

    const now = DateTime.now()
    let expirationStatus: string | undefined = $state()
    if (expiration.diff(now) < DOMAIN_EXPIRATION_IMMINENT) {
        expirationStatus = 'imminent'
    } else if (expiration.diff(now) < DOMAIN_EXPIRATION_SOON) {
        expirationStatus = 'soon'
    }

    let renewalInCart = $derived($items.length && $items.filter((v) => v.type == 'PZONE' && v.meta.a_name == zoneIdna).length > 0)
    let addingToCart = $state(false)
    async function addRenewToCart() {
        if (!cart) return
        if (renewalInCart) return

        addingToCart = true
        const res = await cart.addZone(zoneIdna, 1)
        if (res) {
            notify({
                type: 'success',
                title: $_('Cart'),
                text: $_('Renewal of {name} added to the shopping cart.', { name: zoneUnicode }),
            })
            sgoto('/cart')
        } else {
            addingToCart = false
        }
    }
</script>

<div class="renewal-info es-{expirationStatus}">
    <div class="exp-status">
        <span class="icon">
            <Icon inline icon="bi:clock" />
        </span>
        <span class="tagline">{$_('Ce domaine expire le')}</span>
        <span class="info-date">{expiration.toFormat('yyyy-MM-dd')}</span>
    </div>
    <div class="exp-cart">
        {#if $subaccount.ecom}
            {#if renewalInCart}
                <a use:sanchor href={spath('/cart')}>{$_('In cart')}</a>
            {:else if addingToCart}
                <span><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div></span>
            {:else}
                <a
                    href="/"
                    onclick={(e) => {
                        e.preventDefault()
                        addRenewToCart()
                    }}>{$_('Renew')}</a
                >
            {/if}
        {/if}
    </div>
</div>
